import './polyfill';
import sal from 'sal.js';
import objectFitImages from 'object-fit-images';
import ScrollTo from './modules/scroll-to';
import { init as mediaInit } from './modules/media';
import { init as formsInit } from './modules/forms';
import { init as countInit } from './modules/countup';
import { init as imageGridInit } from './modules/image-grid';
import { hash } from './modules/hash';
import { init as tooltipsInit } from './modules/tooltips';
import { scrollAnimation } from './modules/scroll-animation';
import { init as moreInit } from './modules/more';
import { init as gridListInit } from './modules/grid-list';
import { cookieBanner } from './modules/cookie-banner';
import { socialShare } from './modules/social-share';
import { communityPopup } from './modules/community-popup';

class App {
  constructor() {
    App.importComponents();
    App.addEventListeners();
    App.focusOutline();

    // If document already loaded, call init
    if (document.readyState !== 'loading') {
      App.init();
    }
  }

  static importComponents() {
    App.importAll(require.context('./components/', true, /\.js$/));
  }

  static importAll(r) {
    r.keys().forEach(r);
  }

  static addEventListeners() {
    document.addEventListener('DOMContentLoaded', App.init);
    App.addPrintListener();
  }

  static focusOutline() {
    const noKeyboardClass = 'no-keyboard-navigation-in-use';

    // Add default class to html
    document.documentElement.classList.add(noKeyboardClass);

    // On keyboard use, remove class
    window.addEventListener('keydown', () => {
      document.documentElement.classList.remove(noKeyboardClass);
    });

    //  On click, add class
    window.addEventListener('click', () => {
      document.documentElement.classList.add(noKeyboardClass);
    });
  }

  static loadElements() {
    const images = [...document.querySelectorAll('wp-img')];

    images.forEach((el) => {
      el.attach();
    });

    const lazySizes =
      'lazySizes' in window ? [...window.lazySizes.elements] : [];

    lazySizes.forEach((el) => {
      window.lazySizes.loader.unveil(el);
    });
  }

  static addPrintListener() {
    if ('onbeforeprint' in window) {
      window.addEventListener('beforeprint', App.loadElements);
    } else if ('matchMedia' in window) {
      let printMedia = matchMedia('print');

      if (!printMedia || !printMedia.addListener) {
        return;
      }

      printMedia.addListener(() => {
        if (printMedia.matches) {
          App.loadElements();
        }
      });
    }
  }

  // Add any callbacks that need to run when content added to the page
  static init() {
    objectFitImages();
    ScrollTo.init();
    mediaInit();
    formsInit();
    countInit();
    imageGridInit();
    tooltipsInit();
    moreInit();
    gridListInit();
    sal({
      threshold: 0.001,
    });
    cookieBanner();
    socialShare();
    communityPopup();
    scrollAnimation();
  }
}

new App();

hash();
